import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MedicalRequest } from 'src/app/_models/PSP/medical-requests.model';
import { MedicationRequestService } from 'src/app/_services/PSP/medication-request.service';

@Component({
  selector: 'app-view-medication-requests',
  templateUrl: './view-medication-requests.component.html',
  styleUrls: ['./view-medication-requests.component.scss'],
})
export class ViewMedicationRequestsComponent implements OnInit {
  tHeads = {
    1: ['Request Date', 'Request Type', 'Address', 'Discount Applied', 'Order Quantity', 'Total Public Price', 'Discount Percentage', 'Total Price After Discount', 'FOC Quantity', 'Empty Boxes Quantity', 'Sales/Purchases Quantity', 'Status'],
    2: ['Request Date', 'Request Type', 'Address', 'Discount Applied', 'Order Quantity', 'Total Public Price', 'Discount Percentage', 'Total Price After Discount', 'FOC Quantity', 'Empty Boxes Quantity', 'Sales/Purchases Quantity', 'Status'],
  };
  theadArray = ['Request Date', 'Request Type', 'Address', 'Discount Applied', 'Order Quantity', 'Total Public Price', 'Discount Percentage', 'Total Price After Discount', 'FOC Quantity', 'Empty Boxes Quantity', 'Sales/Purchases Quantity', 'Status'];
  programmesArray = [];
  apiParams = {
    MedicationRequestTypeIds: '1,2',
    MedicationRequestStatusIds: '1,2',
    sort: true,
    patientId: null,
    programId: null
  };
  patientId: number;
  requests = {
    recent: [] as MedicalRequest[],
    previous: [] as MedicalRequest[],
  };
  patientName;

  constructor(
    private activatedRoute: ActivatedRoute,
    private medicalRequestService: MedicationRequestService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param) => {
      this.patientId = param.patientId;
      if (this.patientId) {
        this.apiParams.patientId = this.patientId;
        this.apiParams.programId = param.programId
        this.medicalRequestService
          .getRequests(this.apiParams)
          .subscribe((res) => {
            this.patientName = res.data.items[0]?.programName;
            res.data.items.map((item)=>{
              const date: Date = new Date(item.creationDate);
              const diffTime = Math.abs(Date.now() - date.valueOf());
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              if(diffDays <= 3){
                this.requests.recent.push(item);
              }else{
                this.requests.previous.push(item);
              }

            })
          });
      }
    });
  }
}
